var exports = {
  "uS": "x127c5a35--0828ad--row_area_parts",
  "Tj": "x127c5a35--0828ad--area_parts",
  "tO": "x127c5a35--0828ad--area_parts_item",
  "KJ": "x127c5a35--0828ad--area_parts_item_link",
  "J1": "x127c5a35--0828ad--area_parts_item_price",
};

module.exports = exports;
